import { DataSource } from '@n7-frontend/core';
import { ITableData } from '@n7-frontend/components';
import {Utils} from './utils';
import { from } from 'rxjs';
export class JobsDS extends DataSource {
    protected transform(data): ITableData {
        if (!data || !data.jobs || !data.jobs.length) {
            return;
        }

        const table = [];
        

        const printRoles = (roles) => {
            let res = '<ul>';
            roles.forEach(role => {
                res += `<li><strong>${role.name}</strong> ` + (role.since ? `dal ${Utils.formatDate(role.since)}</li>` : '');
            });
            return res + '</ul>';
        };

        data.jobs.forEach(job => {
            const nomeImpresa = job.companyName || 'Informazione non disponibile';
            const ruoli = printRoles(job.roles);
            table.push({
                classes: 'BODY',
                cells: [
                    {
                        classes: 'CONTENT',
                        content: nomeImpresa,
                        type: 'html'
                    },
                    {
                        classes: 'CONTENT',
                        content: ruoli,
                        type: 'html'
                    }
                ]
            });
        });

        return {
            classes: 'test-layout-table',
            body: table
        };
    }
}
